import { Button } from '@material-ui/core';
import Carousel from '../../lib/Carousel';

export function MobileLogin(props: any) {
    const getStart = (path: string) => async () => {
        props.updateFirstTimeSettings({ appTourVisited: true });
        props.history.push(`/investor/${path}`);
    };
    return (
        <div className="mobile_mode login-mobile">
            <Carousel>
                <div className="login-carousel-mobile login-carousel-mobile1">
                    <h3>
                        India’s First <span>All-in-one</span> Investment Management Platform
                    </h3>
                    <img src="/images/login-form-1.png" alt="" />
                </div>
                <div className="login-carousel-mobile login-carousel-mobile2">
                    <h3>
                        View your <span>MF portfolio</span> like a <span>PRO!</span>
                    </h3>
                    <img src="/images/login-form-2.png" alt="" />
                </div>
                <div className="login-carousel-mobile login-carousel-mobile3">
                    <h3>
                        Managing your service requests can't get <span>SIMPLER!</span>
                    </h3>
                    <img src="/images/login-form-3.png" alt="" />
                </div>
            </Carousel>
            <Button onClick={getStart('signup')} className="customBtn">
                Get Started
            </Button>
            <Button onClick={getStart('signin')} className="customBtn login-btn">
                Login
            </Button>
            <div className="kfin-cams">
                <p>Brought to you by </p>
                <img className="kfin-cams" src="/images/kfin-cams.svg" alt="" />
            </div>
        </div>
    );
}
